import {DateTime, Zone} from 'luxon';
import {isString} from './type-guards';

export function formatJSDate(
  JSDate: Date | string,
  format: Intl.DateTimeFormatOptions | string,
  options: {zone?: string | Zone} = {zone: 'utc'},
): string {
  const _jsDate = new Date(JSDate);

  if (typeof format === 'string') {
    return DateTime.fromJSDate(_jsDate, options).toFormat(format);
  }

  return DateTime.fromJSDate(_jsDate, options).toLocaleString(format);
}

export function convertToDateTime(date: Date | string): DateTime {
  if (isString(date)) {
    return DateTime.fromISO(date);
  }

  return DateTime.fromJSDate(date);
}

export const renderedDateFormat = (date: Date | undefined) =>
  !date ? null : formatJSDate(new Date(date), DateTime.DATE_SHORT);
